import { useQuery } from '@apollo/client';

import { GQLQuery } from '../../../../gql.generated';
import GET_ALERT from '../../graphql/queries/GET_ALERT';

const useGetAlert = ({
  alertId,
  shouldSkip,
}: {
  alertId: string;
  shouldSkip?: boolean;
}) =>
  useQuery<GQLQuery, { alertId: string }>(GET_ALERT, {
    variables: { alertId },
    skip: shouldSkip,
  });

export default useGetAlert;
